import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { useFormikContext } from "formik";
import { marked } from "marked";
import React, { useEffect, useRef, useState } from "react";
import Ellipse from "../../../../assets/icons/Ellipse";
import HaileyStartIco from "../../../../assets/images/HaileyStartIco.svg";
import CommonButton from "../../../../component/Button";
import CommonTextField from "../../../../component/Input";
import { HandleSkeletion } from "../../../../utils/constants";
import {
  CustomDiv,
  WholePageEllipse,
  WholePageOpacity,
} from "../../../chat-bot/style";
import { CommonGrid2 } from "../../../common-components/StyledComponents";

export default function Justification({
  loading,
  handleChatBotChange,
  chatBotData,
  handleIconClick,
}) {
  const { values, errors, setFieldValue, handleChange } = useFormikContext();
  const debounceTimer = useRef();
  const [data, setData] = useState(values["candidate_fit_summary"]);
  useEffect(() => {
    setData(values["candidate_fit_summary"]);
  }, [values]);

  return (
    <CommonGrid2 container spacing={3}>
      {loading ? (
        <HandleSkeletion height={50} width={"100%"} transform="scale(1)" />
      ) : (
        <>
          {chatBotData.loader && (
            <CustomDiv>
              <WholePageEllipse>
                <Ellipse />
              </WholePageEllipse>
              <WholePageOpacity></WholePageOpacity>
            </CustomDiv>
          )}
          <CommonTextField
            rows={7}
            multiline
            padding={"0px"}
            value={data}
            onChange={(e) => {
              setData(e.target.value);
              if (debounceTimer.current) {
                clearTimeout(debounceTimer.current);
              }
              debounceTimer.current = setTimeout(() => {
                setFieldValue("candidate_fit_summary", e.target.value);
              }, 500);
            }}
          />
        </>
      )}
      <CommonTextField
        border={"1px solid #EAECF0"}
        padding={"15px 15px 15px 10px"}
        paddingRight={5}
        backgroundColor={"#F7F8F9"}
        placeholder={"Ask Hailey anything.."}
        bgColor={"#F7F8F9"}
        value={chatBotData.value}
        onChange={(event) => handleChatBotChange(event, setFieldValue)}
        disabled={chatBotData.loader || loading}
        startIcon={<img src={HaileyStartIco} width={"80%"} height={"100%"} />}
        endComponent={
          <CommonButton
            disabled={chatBotData.loader || loading}
            onClick={() => handleIconClick(setFieldValue)}
            fontWeight={600}
            padding={"8px 25px"}
            value={"Ask AI"}
            endIcon={<AutoAwesomeIcon />}
          />
        }
      />
    </CommonGrid2>
  );
}
